import React, { Component } from 'react'
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from 'recharts'
import { translateName } from '../../utils/i18n'

const COLORS = [
    '#4F46E5',
    '#22C55E',
    '#F97316',
    '#0EA5E9',
    '#EC4899',
    '#EAB308',
    '#6366F1',
    '#14B8A6',
]

const formatSI = (n) => {
    if (Math.abs(n) >= 1e9) return +(n / 1e9).toFixed(1) + 'G'
    if (Math.abs(n) >= 1e6) return +(n / 1e6).toFixed(1) + 'M'
    if (Math.abs(n) >= 1e3) return +(n / 1e3).toFixed(1) + 'k'
    return Math.round(n)
}

class StackedBarChart extends Component {
    shouldComponentUpdate(nextProps) {
        return JSON.stringify(this.props) !== JSON.stringify(nextProps)
    }

    render() {
        const { h, w, data = [], dataKeys, defaultKeys = [], className = 'StackedBarChart', colors = COLORS, absolute = false, axisHeight = 60, t } = this.props

        const keys = dataKeys || defaultKeys

        console.log('keys', keys)
        console.log('data', data)

        if (!keys || keys.length < 1) {
            return <div className={className}>Error: Provide valid keys.</div>
        }

        const xKey = keys[0]
        const seriesKeys = keys.slice(1)

        const processedData = data.map(d => {
            const newRow = { ...d }
            seriesKeys.forEach(k => {
                const path = typeof k === 'string' ? k : k.path
                if (absolute || (typeof k !== 'string' && k.absolute)) {
                    newRow[path] = Math.abs(d[path] || 0)
                }
            })
            return newRow
        })

        return (
            <div className={className} style={{ width: w, height: h }}>
                <ResponsiveContainer width="100%" height="100%">
                <BarChart data={processedData} margin={{ top: 0, right: 30, left: 20, bottom: axisHeight }} maxBarSize={120}>
                    <CartesianGrid strokeDasharray="3 3" vertical={false} />
                    <XAxis
                        dataKey={xKey}
                        tick={{ angle: -35, textAnchor: 'end', fontSize: 10 }}
                        interval={0}
                        height={axisHeight}
                    />
                    <YAxis
                        tickFormatter={formatSI}
                        stroke="#888888"
                        fontSize={10}
                    />
                    <Tooltip
                        formatter={(value, name, props) => {
                            const keyObj = seriesKeys.find(k => (typeof k === 'string' ? k : k.path) === props.dataKey)
                            const label = (keyObj && typeof keyObj !== 'string' && keyObj.tKey)
                                ? t(keyObj.tKey)
                                : t(name)
                            return [typeof value === 'number' ? Math.round(value) : value, label]
                        }}
                    />
                    <Legend
                        verticalAlign="top"
                        align="center"
                        wrapperStyle={{ paddingBottom: 10 }}
                        formatter={(value) => {
                            const keyObj = seriesKeys.find(k => (typeof k === 'string' ? k : k.path) === value)
                            return (keyObj && typeof keyObj !== 'string' && keyObj.tKey)
                                ? t(keyObj.tKey)
                                : t(value)
                        }}
                    />
                    {seriesKeys.map((key, index) => {
                        const path = typeof key === 'string' ? key : key.path
                        const color = (typeof key !== 'string' && key.color) || colors[index % colors.length]
                        return (
                            <Bar
                                key={path}
                                dataKey={path}
                                stackId="a"
                                fill={color}
                                isAnimationActive={true}
                            />
                        )
                    })}
                </BarChart>
                </ResponsiveContainer>
            </div>
        )
    }
}

export default StackedBarChart
 StackedBarChart
